import { lazy } from 'react';

const LockPage = lazy(() => import('./LockPage'));

const LockPageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'lock',
      element: <LockPage />,
    },
  ],
};

export default LockPageConfig;
